export default __webpack_public_path__ + "d75b1a90c90afaed1c99574b9dcde1fc.png";